import React, { Component } from 'react';
import {
	Dialog,
	DialogContent,
	DialogTitle,
	DialogHeader,
	DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

class PopupDialog extends Component {
	goToLink = () => {
		window.location.href = this.props.link;
	};

	renderMessageLines() {
		const { message } = this.props;
		if (!message) return null;

		// Check if the message is not a string
		if (typeof message !== 'string') {
			return <p className="text-sm">{message}</p>;
		}

		// Split the message by newline characters
		const messageLines = message.split('\n');

		return messageLines.map((line, index) => (
			<p key={index} className="text-sm">
				{line}
			</p>
		));
	}

	render() {
		return (
			<Dialog
				open={this.props.open}
				onOpenChange={this.props.handleClosePopupDialog}
			>
				{/* Below xl the dialog can be short (a phone with the keyboard up),
				    so the text scrolls and the actions stay in view. On medium screens
				    the title scrolls with the message, inset clear of the close button.
				    Phones have a larger close button, so the title stays beside it and
				    only the message scrolls, starting far enough below the button's
				    touch area that a tap or drag there isn't taken as the button; if
				    even two lines don't fit, the card scrolls. A landscape phone with
				    the keyboard up (no status bar) gives the card almost all the space. */}
				<DialogContent
					mobileVariant="dialog"
					className="max-xl:flex max-xl:flex-col max-xl:kb-open:gap-3 max-xl:kb-open:py-4 max-md:kb-open:[@media(max-height:560px)]:max-h-[calc(var(--app-height)-0.5rem)]"
				>
					<div className="contents md:max-xl:flex md:max-xl:min-h-0 md:max-xl:flex-col md:max-xl:gap-4 md:max-xl:overflow-y-auto md:max-xl:overscroll-contain md:max-xl:kb-open:gap-3 md:max-xl:kb-open:mr-5">
						<DialogHeader className="max-md:shrink-0 max-sm:px-6 sm:max-md:pr-6 max-md:min-h-5 max-md:kb-open:min-h-8">
							<DialogTitle>{this.props.title}</DialogTitle>
						</DialogHeader>
						<div
							style={{ display: 'flex', flexDirection: 'column' }}
							className="max-md:min-h-8 max-md:overflow-y-auto max-md:overscroll-contain"
						>
							<div>{this.renderMessageLines()}</div>
						</div>
					</div>
					<DialogFooter className="max-xl:shrink-0">
						<Button
							variant="text"
							onClick={this.props.handleClosePopupDialog}
						>
							Cancel
						</Button>
						<Button onClick={this.goToLink}>Go</Button>
					</DialogFooter>
				</DialogContent>
			</Dialog>
		);
	}
}

export default PopupDialog;
